import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FpConfigurationDto } from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FpConfigurationRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  public getFacilityPortalConfiguration(): Observable<FpConfigurationDto> {
    const endpointUrl = `settings/facility-portal/`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  public postFacilityPortalConfiguration(requestDto: FpConfigurationDto): Observable<boolean> {
    const endpointUrl = `settings/facility-portal/`;
    return this.httpClientService.sendPostRequest(endpointUrl, requestDto);
  }
}
